export const ENV = {
  TOKEN: import.meta.env.VITE_TOKEN,
  PAYLOAD: import.meta.env.VITE_PAYLOAD,
  BASE_URL: import.meta.env.VITE_BASE_URL,
  SIGNAL_R: import.meta.env.VITE_SIGNAL_R,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  CRYPTO_JS_IV: import.meta.env.VITE_CRYPTO_JS_IV,
  SURVEY_QUEUES: import.meta.env.VITE_SURVEY_QUEUES,
  CRYPTO_JS_KEY: import.meta.env.VITE_CRYPTO_JS_KEY,
  DATE_PREFERENCE: import.meta.env.VITE_DATE_PREFERENCE,
  CLARITY_CLIENT_ID: import.meta.env.VITE_CLARITY_CLIENT_ID,
  CLARITY_CUSTOMER_ID: import.meta.env.VITE_CLARITY_CUSTOMER_ID,
  CONVERSION_RATE_START_DATE: import.meta.env.VITE_CONVERSION_RATE_START_DATE,
  SIGNALR_RETRY_CONNECTION_TIME: import.meta.env.VITE_SIGNALR_RETRY_CONNECTION_TIME,
  GOOGLE_ANALYTICS_MEASUREMENT_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID,
  CONVERSION_RATE_START_DATE_IN_UTC: import.meta.env.VITE_CONVERSION_RATE_START_DATE_IN_UTC,

  // Keep tests and mock responses on the same configured credentials.
  PASSWORD_VALUE: import.meta.env.VITE_PASSWORD_VALUE,
  PASSWORD_NEW_VALUE: import.meta.env.VITE_PASSWORD_NEW_VALUE,
  USER_TEST_PASSWORD: import.meta.env.VITE_USER_TEST_PASSWORD,
  SUPER_ADMIN_TEST_EMAIL: import.meta.env.VITE_SUPER_ADMIN_TEST_EMAIL,
  BRAND_ADMIN_TEST_EMAIL: import.meta.env.VITE_BRAND_ADMIN_TEST_EMAIL,
  GROUP_ADMIN_TEST_EMAIL: import.meta.env.VITE_GROUP_ADMIN_TEST_EMAIL,
  MANAGER_ADMIN_TEST_EMAIL: import.meta.env.VITE_MANAGER_ADMIN_TEST_EMAIL,
  PASSWORD_WITH_CAPITAL_LETTER: import.meta.env.VITE_PASSWORD_WITH_CAPITAL_LETTER,
  INBOX_GROUP_ADMIN_TEST_EMAIL: import.meta.env.VITE_INBOX_GROUP_ADMIN_TEST_EMAIL,
  PASSWORD_WITH_CAPITAL_LETTER_AND_NUMBER:
    import.meta.env.VITE_PASSWORD_WITH_CAPITAL_LETTER_AND_NUMBER,
  PASSWORD_WITH_CAPITAL_LETTER_NUMBER_AND_SPECIAL_CHAR:
    import.meta.env.VITE_PASSWORD_WITH_CAPITAL_LETTER_NUMBER_AND_SPECIAL_CHAR,
  PASSWORD_WITH_CAPITAL_LETTER_NUMBER_SPECIAL_CHAR_AND_FULL_LENGTH:
    import.meta.env.VITE_PASSWORD_WITH_CAPITAL_LETTER_NUMBER_SPECIAL_CHAR_AND_FULL_LENGTH,
};
